export const INBOUND_MSG_TYPE = {
    HELLO: "HELLO",
    PING: "PING",
    CALL_CREATE: "CALL_CREATE",
    CALL_ACCEPT: "CALL_ACCEPT",
    CALL_REJECT: "CALL_REJECT",
    CALL_END: "CALL_END",
    SDP_OFFER: "SDP_OFFER",
    SDP_ANSWER: "SDP_ANSWER",
    ICE_CANDIDATE: "ICE_CANDIDATE",
    PC_CONNECTION_STATE: "PC_CONNECTION_STATE",
    ACK: "ACK"
};
